/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-expansion-panel[_ngcontent-%COMP%]{box-shadow:none;border:1px solid #dee2e6}.mat-expansion-panel[_ngcontent-%COMP%]   .mat-expansion-panel-header-title.opened[_ngcontent-%COMP%]   .panel-title--closed[_ngcontent-%COMP%], .mat-expansion-panel[_ngcontent-%COMP%]   .mat-expansion-panel-header-title[_ngcontent-%COMP%]:not(.opened)   .panel-title--opened[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
